export default (raw) => {
  const text = '' + raw;
  return text.charAt(0).toUpperCase() + text.slice(1);
};
